import React, { FunctionComponent } from 'react';
import { Icon, Spinner } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Helmet } from 'react-helmet';

import './WorkspaceSelection.scss';
import { IWorkspace } from '../../models';
import { PanelTitle } from '../layout/PanelTitle';
import { HeaderTitle } from '../layout/HeaderTitle';
import { WorkspaceItem } from './WorkspaceItem';
import { IUser } from '../../models';
import config from '../../../config';

type CurrentUser = IUser | undefined | null;

type WorkspaceSelectionProps = {
  workspaces: IWorkspace[];
  workspacesLoading: boolean;
  switchingWorkspace: string | null;
  currentUser: CurrentUser;
  onSelectWorkspace: (workspace: IWorkspace) => void;
};

export const WorkspaceSelection: FunctionComponent<WorkspaceSelectionProps> = ({
  workspaces, workspacesLoading,
  switchingWorkspace,
  currentUser, onSelectWorkspace
}: WorkspaceSelectionProps) => {

  return (
    <div className="workspace-selection">
      <Helmet>
        <title>
          Select Your Workspace
        </title>
      </Helmet>
      <PanelTitle>
        <Icon icon={IconNames.APPLICATION} />
        Select Your Workspace
      </PanelTitle>
      <HeaderTitle>
        <div className="header__navigation__label">
          <Icon icon={IconNames.APPLICATION} />
          Select Your Workspace
        </div>
      </HeaderTitle>

      <div className="workspace-selection__select-workspace">
        <div className="workspace-selection__select-workspace__title">
          Available workspaces for {currentUser?.email}:
        </div>
        <div className="workspace-selection__select-workspace__workspaces">
          {
            workspacesLoading ? (
              <Spinner size={20} />
            ) : workspaces.map(workspace => (
              <WorkspaceItem
                key={workspace.uid}
                workspace={workspace}
                workspaces={workspaces}
                loading={workspace.uid === switchingWorkspace}
                onSelect={onSelectWorkspace}
              />
            ))
          }
        </div>
        <div className="workspace-selection__select-workspace__list">
          <div className="workspace-selection__select-workspace__list__hint">
            <strong>Not seeing your workspace?</strong> Try using a <a href={config.app.url + '/logout'}>different email</a>.
          </div>
        </div>
      </div>
    </div>
  );
};
